<template>
  <div id="app">
    <Header/>
    <router-view/>
  </div>
</template>

<script>
import Header from './components/common/Header'
export default {
  name: 'App',
  components: {
    Header
  }
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  margin-top: 0px;
  height: 100%;
}
html{
  height:100%;
}
body{
  margin:0px;
  height:100%;
  width: 100%;
}
h1,h2,h3,h4,h5,h6{
  font-family: Hiragino Kaku Gothic Std;
}
li{
  /*font-family: Hiragino Kaku Gothic Std;*/
}
a{
  /*font-family: Hiragino Kaku Gothic Std;*/
  text-decoration: none;
}
p {
  /*font-family: Hiragino Kaku Gothic Std;*/
}
.pc{
  display: block;
}
.sp{
  display: none;
}
@media ( max-width : 780px ){
  .pc{
  display: none;
}
.sp{
  display: block;
}
}
</style>



// WEBPACK FOOTER //
// src/App.vue